"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.reflect.construct");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));
var _getPrototypeOf2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));
var _inherits2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _serviceBase = _interopRequireDefault(require("@/services/service-base"));
var _qs = _interopRequireDefault(require("qs"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var domain_p = process.env.VUE_APP_BASE_API_LOGIN;
var AccountService = /*#__PURE__*/function (_Service) {
  function AccountService() {
    (0, _classCallCheck2.default)(this, AccountService);
    return _callSuper(this, AccountService, arguments);
  }
  (0, _inherits2.default)(AccountService, _Service);
  return (0, _createClass2.default)(AccountService, [{
    key: "getAccountList",
    value: function getAccountList(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.get(domain_p + "/v2/users?".concat(_qs.default.stringify(param)), {
        headers: {
          platform: param.siteName
        }
        // headers: {platform:'mx'}
      });
    }
  }, {
    key: "getList",
    value: function getList(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.get(domain_p + "/vwk/user/index?".concat(_qs.default.stringify(param)));
    }
  }, {
    key: "add",
    value: function add(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.post(domain_p + '/vwk/user/add', param);
    }
  }, {
    key: "getInfo",
    value: function getInfo(param) {
      param.pid = process.env.VUE_APP_PID;
      var id = param.id,
        other = param.other,
        pid = param.pid;
      return this.http.get(domain_p + "/v2/user/edit/".concat(id, "?").concat(_qs.default.stringify(other), "&pid=").concat(pid));
    }
  }, {
    key: "edit",
    value: function edit(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.post(domain_p + "/v2/user/edit/".concat(param.id), param);
    }
  }, {
    key: "del",
    value: function del(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.post(domain_p + "/v2/user/del/".concat(param.id, "?pid=").concat(param.pid));
    }
  }, {
    key: "opera",
    value: function opera(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.post(domain_p + "/v2/user/update/".concat(param.id), param);
    }
  }, {
    key: "openAuth",
    value: function openAuth(data) {
      return this.http.post(domain_p + "/v2/user/auth/open/".concat(data.id), data);
    }
  }, {
    key: "closeAuth",
    value: function closeAuth(data) {
      return this.http.post(domain_p + "/v2/user/auth/close/".concat(data.id), data);
    }
  }, {
    key: "resetAuth",
    value: function resetAuth(data) {
      return this.http.post(domain_p + "/v2/user/auth/reset/".concat(data.id), data);
    }
  }]);
}(_serviceBase.default);
var _default = exports.default = new AccountService({
  // baseURL: process.env.VUE_APP_BASE_API_LOGIN
});